export const CART = "CART";
export const DONATION_AMOUNT = "DONATION_AMOUNT";
export const ORDER_COMMENTS = "ORDER_COMMENTS";
export const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
export const CONTACT_ROUTE = "/contact/";
export const ABOUT_ROUTE = "/about/";
export const CHECKOUT_ROUTE = "/checkout/";
export const DOG_DAYS_ROUTE = "/dog-treats/";
export const DOG_DAYS_PAGE_TITLE = "Dog Treats";
export const ORDER_SUCCESS_SUFFIX = "order-success/";
export const ORDER_SUCCESS_ROUTE = `${CHECKOUT_ROUTE}${ORDER_SUCCESS_SUFFIX}`;
export const PRODUCT_IMAGE_ASPECT_RATIO = 1;
export const PAYMENT_METHOD_BRANDS = ["visa", "mastercard", "amex", "discover"];
export const NAV_ITEMS = [
  {
    label: "ABOUT US",
    to: ABOUT_ROUTE,
  },
  {
    label: "CONTACT US",
    to: CONTACT_ROUTE,
  },
  { label: DOG_DAYS_PAGE_TITLE.toUpperCase(), to: DOG_DAYS_ROUTE },
  { label: "Silver Wolf Studio".toUpperCase(), to: "/studio/" },
  { label: "Silver Wolf Swag".toUpperCase(), to: "/swag/" },
];

export const SHIPPING_CHARGE = 999;
export const SUPPORT_EMAIL_ADDRESS = "shops@philipsacademync.org";
